import { render, staticRenderFns } from "./ButtonPair.vue?vue&type=template&id=0cacbc1e&scoped=true&"
import script from "./ButtonPair.vue?vue&type=script&lang=ts&"
export * from "./ButtonPair.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPair.vue?vue&type=style&index=0&id=0cacbc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cacbc1e",
  null
  
)

export default component.exports